import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
/**
 * Required group validator used for checkbox and toggle
 * @returns
 */
export function RequiredGroupValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value && typeof control.value[0] === 'boolean') {
      if (!control.value.includes(true)) {
        return { required: true };
      }
    } else {
      if (
        !control.value ||
        control.value[0] === undefined ||
        control.value[0] === ''
      ) {
        return { required: true };
      }
    }
    return null;
  };
}
